import * as actionTypes from './actionTypes';
import { SummaryModel } from '@app/src/views/StepThree/publicationConfirmation/models';

interface State {
  data: SummaryModel;
  dataWeb: any;
  isFetching: boolean;
  error: boolean;
}

const initialState: State = {
  data: {
    price: {
      subTotal: '',
      igv: null,
      totalIgv: '',
      total: '',
      discount: null,
      totalDiscount: ''
    },
    print: []
  },
  dataWeb: {},
  isFetching: false,
  error: false
};

export const summary = (state: State = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SUMMARY_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case actionTypes.FETCH_SUMMARY_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      };
    case actionTypes.FETCH_SUMMARY_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      };
    case actionTypes.FETCH_SUMMARY_WEB_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        dataWeb: action.data
      };
    default:
      return state;
  }
};
